import styled from '@emotion/styled';
import { Grid, Typography } from '@mui/material';
import { colors } from 'theme/colors';
import { Theme } from '@mui/system';

export const StyledFirearmListBox = styled(Grid)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px;
  border-radius: 4px;
  border: 1px solid ${colors.gray200};
  background-color: ${colors.white};
`;

export const StyledLocationMarkConfirmation = styled.div`
  width: fit-content;
  white-space: nowrap;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 6px 6px 6px 16px;
  margin-right: 16px;
  margin-bottom: 16px !important;
  background-color: ${colors.success50};
  border-radius: 4px;
`;
export const StyledLocationMarkConfirmationMarginBottom = styled.div`
  width: fit-content;
  white-space: nowrap;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  min-height: 32px;
  height: auto;
  padding: 6px 6px 6px 16px;
  margin-right: 0px !important;
  margin-top: 28px !important;
  margin-bottom: 28px !important;
  background-color: ${colors.success50};
  border-radius: 4px;
`;

export const StyledIconWrapper = styled.div`
  width: 20px;
  height: 20px;
  padding: 3px;
  border-radius: 2px;
  display: flex;
  justify-content: start;
  align-items: center;
  margin-left: 6px;
  background-color: ${colors.success900};
`;

export const StyledTitleFirearmInformation = styled(Typography)`
  color: ${colors.primary500};
  font-weight: 600;
  margin-bottom: 8px;
  text-transform: uppercase;
`;

export const StyledLine = styled(Grid)`
  border-top: 1px solid ${colors.primary100};
  margin: 10px 16px;
`;
